export interface MenuState {
  menusInCart: MenuInCart[] | null;
  menusToReorder: MenuInCart[] | null;
}

export interface Category {
  id: number;
  name: string;
  text: string;
  sortOrder: number;
  count: number;
  menus: Menu[];
}

// 在庫販売グループ
export interface StockGroup {
  id: number;
  groupName: string;
  stockRemaining: number;
  limitQtyPerUser: number;
  userOrderedQty: number | null;
  orderableQty: number; // フロントで計算済みの注文可能数
  isSoldOut: boolean; // 在庫0
  isUserLimitReached: boolean; // ユーザー注文上限到達
  categories: Category[];
}

export interface Menu {
  id: number;
  name: string;
  code: string;
  categoryId: number;
  imageUrl: string;
  price: number;
  priceWithTax: number;
  isFavorite: boolean;
  isEnableButton: boolean;
  isPreorder: boolean;
  preorderMessage: string;
  isLimitedMenu: boolean;
  isRecommended: boolean;
  recommendOrder: number | null;
  details?: string;
  options: MenuOption[];
  campaign: MenuCampaign | null;
  isEarlyBird: boolean;
  stockGroupId?: number; // 在庫販売グループID
  orderableQty?: number; // 在庫販売グループの注文可能数
}

export enum EarlyBirdEligible {
  None = 0, // Not displayed on early bird screen
  EarlyBird = 1, // Displayed on early bird discount screen
  Both = 2, // Displayed for both early bird and regular screen
}

export interface MenuOption {
  id: number;
  name: string;
}

interface MenuCampaign {
  price: number;
  priceWithTax: number;
  details: string;
}

export type MenuInCart = {
  couponUuid?: string;
  menuId: number;
  menuName: string;
  amount: number;
  optionId?: number;
  optionName?: string;
  couponCode?: string;
  isEarlyBird: boolean;
};
